import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { differenceInDays } from 'date-fns';
import { useState } from 'react';
export var bannerStorageKeys = /*#__PURE__*/function (bannerStorageKeys) {
  bannerStorageKeys["students"] = "students";
  bannerStorageKeys["whatsapp"] = "whatsapp";
  return bannerStorageKeys;
}({});
var DISMISS_TIME_IN_DAYS = 3;
export function useBannerStorage(pageKey, campaignName, campaignUniqueKey, dismissExpiry) {
  var _useState = useState(Date.now()),
    _useState2 = _slicedToArray(_useState, 2),
    setLastUpdated = _useState2[1];
  var storedData = JSON.parse(localStorage.getItem('marketing-banners-control') || '{}');
  var shouldSetLocalStorageKey = !process.env.STORYBOOK && !storedData[pageKey];
  if (shouldSetLocalStorageKey) {
    storedData[pageKey] = {
      dismissedAt: '',
      dismissCount: 0,
      campaign: '',
      bannerContentHash: ''
    };
    localStorage.setItem('marketing-banners-control', JSON.stringify(storedData));
  }
  function shouldDisplayBanner() {
    var _storedData$pageKey, _storedData$pageKey2, _storedData$pageKey$d, _storedData$pageKey3, _storedData$pageKey$d2, _storedData$pageKey4;
    if (!((_storedData$pageKey = storedData[pageKey]) !== null && _storedData$pageKey !== void 0 && _storedData$pageKey.dismissedAt) || ((_storedData$pageKey2 = storedData[pageKey]) === null || _storedData$pageKey2 === void 0 ? void 0 : _storedData$pageKey2.bannerContentHash) !== campaignUniqueKey) {
      return true;
    }
    var dismissCount = (_storedData$pageKey$d = (_storedData$pageKey3 = storedData[pageKey]) === null || _storedData$pageKey3 === void 0 ? void 0 : _storedData$pageKey3.dismissCount) !== null && _storedData$pageKey$d !== void 0 ? _storedData$pageKey$d : 0;
    var dismissedDate = (_storedData$pageKey$d2 = (_storedData$pageKey4 = storedData[pageKey]) === null || _storedData$pageKey4 === void 0 ? void 0 : _storedData$pageKey4.dismissedAt) !== null && _storedData$pageKey$d2 !== void 0 ? _storedData$pageKey$d2 : '';
    if (dismissCount > 1) {
      return false;
    }
    var currentDate = new Date();
    var lastDismissedDate = new Date(dismissedDate);
    var timeDifference = differenceInDays(currentDate, lastDismissedDate);
    var evaluatedDismissExpiry = dismissExpiry || DISMISS_TIME_IN_DAYS;
    return timeDifference > evaluatedDismissExpiry;
  }
  function dismissBanner() {
    var _storedData$pageKey5;
    var currentTime = new Date().toISOString();
    storedData[pageKey] = {
      dismissedAt: currentTime,
      dismissCount: (((_storedData$pageKey5 = storedData[pageKey]) === null || _storedData$pageKey5 === void 0 ? void 0 : _storedData$pageKey5.dismissCount) || 0) + 1,
      campaign: campaignName,
      bannerContentHash: campaignUniqueKey
    };
    localStorage.setItem('marketing-banners-control', JSON.stringify(storedData));
    setLastUpdated(Date.now());
  }
  return {
    shouldDisplayBanner: shouldDisplayBanner,
    dismissBanner: dismissBanner
  };
}